module.exports = __webpack_public_path__ + "components/flag/static/square/mx-57d64c6fa3b4af540bb77bd01567a544.svg";